// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IConsultationRequestV1Schema {
  /** Имя клиента **/
  name: string;
  /** Сервис, из которого поступил запрос на консультацию **/
  origin: EOrigin;
  /** Телефон клиента **/
  phone: string;
  /** Откуда поступила заявка (на русском) **/
  sentFrom: string;
}
export enum EOrigin {
  /** Циан.Сделка **/
  'E2eDeal' = 'e2eDeal',
  /** Циан.Ипотека для профи **/
  'Mortgage' = 'mortgage',
  /** Заработай с ЦИАН **/
  'PartnerRewards' = 'partnerRewards',
}
